export const LOGIN_SUCCESSFUL = "LOGIN_SUCCESSFUL";
export const LOGIN_FAILED = "LOGIN_FAILED";
export const SUCCESSFUL_GET_USER_INFO  = "SUCCESSFUL_GET_USER";


// WEBPACK FOOTER //
// ./src/reducers/user/actionConst.js